import {
  StyledHeader,
  StyledSummaryHeader,
  StyledTooltip,
  StyledTotalStats
} from './Tooltip.style';
import { LINB_ISSUE_STATES } from '../../../state/issue.statuses';
import DeltaIndicator from './components/DeltaIndicator';
import DeltaText from './components/DeltaText';
import StatItem from './components/StatItem';
import { getPeriodDurationText } from 'components/PeriodPicker/periods/utils';
import { getRoundedValue } from '../../../../../ResourceAllocationOverview/resource-allocation.formatters';

const Tooltip = ({ data, type, granularity, withoutDelta }) => {
  const { start_period, end_period } = data;
  const completePercent = data?.progression_completion;
  const delta = getRoundedValue(data?.progression_deviation);
  const totalTODO = data?.[LINB_ISSUE_STATES.CREATED];
  const totalWIP = data?.[LINB_ISSUE_STATES.WIP];
  const totalDONE = data?.[LINB_ISSUE_STATES.DONE];

  const periodDurationText = getPeriodDurationText(start_period, end_period);
  const completePercentText = isNaN(completePercent)
    ? 'N/A'
    : `${getRoundedValue(completePercent)}%`;

  return (
    <StyledTooltip>
      <StyledHeader>
        <>{periodDurationText}</>
        <DeltaIndicator delta={delta} />
      </StyledHeader>
      <StyledSummaryHeader>
        {completePercentText} completion
        <DeltaText
          delta={delta}
          granularity={granularity}
          hidden={withoutDelta}
        />
      </StyledSummaryHeader>
      <StyledTotalStats>
        <StatItem value={totalTODO} text={`${type?.name} to do`} />
        <StatItem value={totalWIP} text={`${type?.name} in-progress`} />
        <StatItem value={totalDONE} text={`${type?.name} completed`} />
      </StyledTotalStats>
    </StyledTooltip>
  );
};

export default Tooltip;
